import React, { Component } from 'react';
import { connect } from 'react-redux';

class NoMatch extends Component {
  render() {
    return <label className="areaTexto">Rota não encontrada</label>;
  }
}

export default connect()(NoMatch);
